import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { novos_renovados_segmento_total_2 } from "../../services/api";
import './tabelas_matricula.css'; // Importando nosso CSS padronizado

const Fidelizacao_serie_comparativa2 = (props) => {
    const [dataTotal2, setDataTotal2] = useState([]);
    const [isloading, setIsloading] = useState(true);

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response2 = await novos_renovados_segmento_total_2(data_inicio, data_fim);
            setDataTotal2(response2 || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        const labels = {
            '0-1': 'Mat 1', '0-2': 'Mat 2', '0-3': 'Pré 1', '0-4': 'Pré 2',
            '1-1': '1º Fund I', '1-2': '2º Fund I', '1-3': '3º Fund I', '1-4': '4º Fund I', '1-5': '5º Fund I',
            '1-6': '6º Fund II', '1-7': '7º Fund II', '1-8': '8º Fund II', '1-9': '9º Fund II',
            '2-1': '1ª Médio', '2-2': '2ª Médio', '2-3': '3ª Médio'
        };
        return labels[seg] || seg;
    };

    // Função para replicar as cores de variação do Google Charts
    const getVarClass = (value) => {
        if (value > 0) return "bg-green";
        if (value < 0) return "bg-red";
        return "";
    };

    let totais = { p27: 0, r27: 0, p26: 0, r26: 0 };

    let processedData = [];
    if (!isloading) {
        processedData = dataTotal2.map((item) => {
            const p27 = parseFloat(item.pr27) || 0;
            const r27 = parseFloat(item.rn27) || 0;
            const tx27 = p27 > 0 ? (r27 / p27) * 100 : 0;

            const p26 = parseFloat(item.pr26) || 0;
            const r26 = parseFloat(item.rn26) || 0;
            const tx26 = p26 > 0 ? (r26 / p26) * 100 : 0;

            const variacao = tx27 - tx26;

            totais.p27 += p27; totais.r27 += r27;
            totais.p26 += p26; totais.r26 += r26;

            return {
                seg: convertSegmento(item.segmento),
                p27, r27, tx27,
                p26, r26, tx26,
                variacao
            };
        });
    }

    const txTotal27 = totais.p27 > 0 ? (totais.r27 / totais.p27) * 100 : 0;
    const txTotal26 = totais.p26 > 0 ? (totais.r26 / totais.p26) * 100 : 0;
    const varTotal = txTotal27 - txTotal26;

    return (
        <div className="mt-3">
            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                    <thead className="table-dark">
                        <tr>
                            <th className="text-start ps-3">SEGMENTO</th>
                            <th>P 27</th><th>R 27</th><th>R27 %</th>
                            <th>P 26</th><th>R 26</th><th>R26 %</th>
                            <th>Variação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isloading ? (
                            <tr><td colSpan="8" className="py-4 text-muted">Carregando dados...</td></tr>
                        ) : (
                            processedData.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="text-start fw-bold bg-light ps-3">{row.seg}</td>
                                    <td className="text-primary">{row.p27}</td>
                                    <td className="text-primary">{row.r27}</td>
                                    <td className="text-primary fw-bold">{row.tx27.toFixed(2)}%</td>

                                    <td className="text-danger">{row.p26}</td>
                                    <td className="text-danger">{row.r26}</td>
                                    <td className="text-danger fw-bold">{row.tx26.toFixed(2)}%</td>

                                    <td className={getVarClass(row.variacao)}>
                                        {row.variacao > 0 ? '+' : ''}{row.variacao.toFixed(2)}%
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                    {!isloading && processedData.length > 0 && (
                        <tfoot className="fw-bolder border-top border-dark bg-light">
                            <tr>
                                <td className="text-start ps-3">TOTAL</td>
                                <td className="text-primary">{totais.p27}</td>
                                <td className="text-primary">{totais.r27}</td>
                                <td className="text-primary">{txTotal27.toFixed(2)}%</td>

                                <td className="text-danger">{totais.p26}</td>
                                <td className="text-danger">{totais.r26}</td>
                                <td className="text-danger">{txTotal26.toFixed(2)}%</td>

                                <td className={getVarClass(varTotal)}>
                                    {varTotal > 0 ? '+' : ''}{varTotal.toFixed(2)}%
                                </td>
                            </tr>
                        </tfoot>
                    )}
                </Table>
            </div>
        </div>
    );
};

export default Fidelizacao_serie_comparativa2;